// ...existing imports...
import { Component, ChangeDetectorRef, ElementRef, HostListener, Input, NgZone, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SearchService } from 'src/app/services/search.service';
import { MessageService } from 'primeng/api';
import { ExpeditionDto } from '../../../models/expedition-dto';
import { ExcavationDto } from '../../../models/excavation-dto';
import { SurveyDto } from '../../../models/survey-dto';

import {
  fadeInOnEnterAnimation,
  fadeOutOnLeaveAnimation,
} from 'angular-animations';
import { RequestKeys } from 'src/app/enums/request-keys.enum';
import { TabId } from 'src/app/enums/tab-id.enum';
import { EntityTypeService } from 'src/app/services/entity-type.service';
import { SearchFieldsService } from 'src/app/services/search-fields.service';
import { FieldsListsService } from 'src/app/services/fields-lists.service';
import { TreeService } from 'src/app/services/tree.service';
import { RoutingService } from 'src/app/services/routing.service';
import { SearchFieldsDto } from 'src/app/models/search-fields-dto';
import { FieldsListsDto } from 'src/app/models/fields-lists-dto';
import { SearchFieldDto, ThesaurusSearchType } from 'src/app/models/search-field-dto';
import { FIELD_MAPPING } from 'src/app/constants';

import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { Panel } from 'primeng/panel';
import { MultiLangStrDto } from 'src/app/models/multi-lang-str-dto';
import { Observable, Subscription } from 'rxjs';
import { LanguageService } from 'src/app/services/language.service';
import { CustomTreeNode } from 'src/app/models/custom-tree-node';
import { ThesaurusTreeNode } from 'src/app/models/thesaurus-tree-node';
import { SelectableTreeNode } from 'src/app/models/selectable-tree-node';
import { ControlType } from '../../arcgis-map/constants/control-type.enum';
import { MapControlItem } from '../../arcgis-map/constants/map-control-item.interface';
import { NaturalLanguageSearchService } from 'src/app/services/natural-language-search.service';
import { ARCGIS_MAP_LIFECYCLE } from '../../arcgis-map/constants/map-life-cycle.interface';
import { SearchAdvancedMapService } from '../../arcgis-map/services/search-advanced-map.service';
import { ShapeItem } from '../../arcgis-map/constants/shape-item.interface';
import { TranslateService } from '@ngx-translate/core';
import { SearchTreeComponent } from '../search-tree/search-tree.component';
import { ThesaurusSearchTreeComponent } from '../thesaurus-search-tree/thesaurus-search-tree.component';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-search-advanced',
  templateUrl: './search-advanced.component.html',
  styleUrls: ['./search-advanced.component.scss'],
    providers: [MessageService,
      {
        provide: ARCGIS_MAP_LIFECYCLE,
        useClass: SearchAdvancedMapService,
      },
    ],
  animations: [fadeInOnEnterAnimation(), fadeOutOnLeaveAnimation()],
})
export class AdvancedSearchComponent implements OnInit, OnDestroy {
      onDialogHide(dialogName: string) {
        // Use longer timeout to ensure dialog is fully closed and DOM is stable
        setTimeout(() => {
          const elementId = `${dialogName}Opener`;
          const element = document.getElementById(elementId);
          
          if (element) {
            element.focus();
          }
        }, 100);
      }
  isMobile = window.innerWidth < 768;
  @ViewChild('panelRef') panelRef!: Panel;
  @ViewChild('panelElementRef', { read: ElementRef }) panelElementRef!: ElementRef;
  @ViewChild('advancedThesaurusTree') advancedThesaurusTree?: ThesaurusSearchTreeComponent;
  
  RequestKeys = RequestKeys;
  searchFields: SearchFieldsDto = {} as SearchFieldsDto;
  freeText: string = '';
  regions: any[] = [];
  virtualExpeditions!: ExpeditionDto[];
  fieldsLists: FieldsListsDto = {} as FieldsListsDto;
  isSettlementVisible: boolean = false;
  activeTabIndex: number = TabId.DEFAULT;
  isDrawPolygon: boolean = false;
  isMaterialVisible: boolean = false;
  isPeriodVisible: boolean = false;
  isExpeditionVisible: boolean = false;
  isExpeditionDialogVisible = false;
  combinedExpeditionValues: any[] = [];
  isExcavationsAndSurveysVisible: boolean = false;
  isExcavationsAndSurveysDialogVisible = false;
  combinedExcavationsAndSurveysValues: any[] = [];
  isLicenseVisible: boolean = false;
  isRegionVisible: boolean = false;
  isMerchaVisible: boolean = false;
  isFreeTextVisible: boolean = false;
  isThesaurusVisible: boolean = false;
  isThesaurusAdvancedVisible: boolean = false;
  isThesaurusDataLoading: boolean = true;
  selectedThesaurusCategory: any = null;
  activeThesaurusCategory: any = null;
  currentAdvancedThesaurusTree: ThesaurusTreeNode | null = null;
  thesaurusAllCategories: any[] = [];
  filteredCategories: any[] = [];
  transformedThesaurusTrees: { [categoryId: number]: ThesaurusTreeNode } = {};
  cachedMergedTree: ThesaurusTreeNode | null = null;
  tempAdvancedThesaurusSelections: { [categoryId: number]: SearchFieldDto[] } = {};
  searchTypePreferences: { [categoryId: number]: { [nodeId: string]: ThesaurusSearchType } } = {};
  cachedGroupedSelections: Array<{categoryId: number, categoryName: string, selections: SearchFieldDto[]}> = [];
  isFindTypeVisible: boolean = false;
  isEntityTypeVisible: boolean = false;
  isHachrazaVisible: boolean = false;
  isHeritageSiteVisible: boolean = false;
  isInternalUser: boolean = false;
  isPersonVisible: boolean = false;
  isSearchValid: boolean = true;
  isSearchTriggered: boolean = false;
  isLoading: boolean = false;
  isSearchSettingsVisible: boolean = false;
  withThesaurusAncestors: boolean = true;
  withEntityAncestors: boolean = false;
  tempWithThesaurusAncestors: boolean = true;
  tempWithEntityAncestors: boolean = false;
  initialWithThesaurusAncestors: boolean = true;
  initialWithEntityAncestors: boolean = false;
  onMapRegionsDeleted = false;
  polygonsNumber: number = 0;
  polygonsPopupClosed = false;
  polygons: any[] = [];
  private _isCollapsed: boolean = false;
  get isCollapsed(): boolean {
    return this._isCollapsed;
  }
  set isCollapsed(value: boolean) {
    const wasCollapsed = this._isCollapsed;
    this._isCollapsed = value;
    
    // Close search settings dialog when panel becomes collapsed
    if (!wasCollapsed && value && this.isSearchSettingsVisible) {
      this.closeSearchSettings();
    }
  }
  LABELS = {
    mapView: 'mapView',
  }
  private languageSubscription?: Subscription;
  currentLanguage: 'he' | 'en' = 'he';
  colsExpeditions: any = [{ field: 'expeditionNameHeb', header: 'Name' }];
  
  @HostListener('window:resize')
  onResize() {
    this.isMobile = window.innerWidth < 768;
  }
  constructor(
    public searchService: SearchService,
    private RoutingService: RoutingService,
    private entityTypeService: EntityTypeService,
    private messageService: MessageService,
    private fieldsListsService: FieldsListsService,
    private searchFieldsService: SearchFieldsService,
    private treeService: TreeService,
    protected $gaService: GoogleAnalyticsService,
    private translate: TranslateService,
    private languageService: LanguageService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private authService: AuthService ) { }
    
  mapControls: MapControlItem[] = [];

  private getNumericId(compositeId: string): string {
    return compositeId.split('-')[0];
  }

  ngOnInit(): void {
    // Check for autoExpandSearch query parameter and collapse panel if true
    this.route.queryParams.subscribe(params => {
      if (params['autoExpandSearch'] === 'true') {
        this.isCollapsed = true;
      }
    });

    this.authService.internalUser$.subscribe(isInternal => {
      this.isInternalUser = isInternal;
    });

    this.languageSubscription = this.languageService.currentLanguage$.subscribe((language: string) => {
      this.currentLanguage = language as 'he' | 'en';
      this.populateMapControls();
      
      if(this.fieldsLists.periods && this.fieldsLists.findTypes && this.fieldsLists.materials){
        this.fieldsLists.periods = this.transformToTreeNode(this.fieldsLists.periods);
        this.fieldsLists.findTypes = this.transformToTreeNode(this.fieldsLists.findTypes);
        this.fieldsLists.materials = this.transformToTreeNode(this.fieldsLists.materials);
      }
      
      // Re-transform thesaurus trees when language changes
      if (this.fieldsLists.thesaurusAll?.categories) {
        this.initializeThesaurusCategories();

        // Refresh filteredCategories with new language displayText
        this.filteredCategories = this.thesaurusAllCategories.map(cat => ({
          ...cat,
          displayText: this.currentLanguage === 'he' ? cat.categoryName.hebrew : cat.categoryName.english
        }));

        // Re-find selectedThesaurusCategory and activeThesaurusCategory in the new list
        if (this.selectedThesaurusCategory) {
          const refreshed = this.filteredCategories.find(c => c.categoryId === this.selectedThesaurusCategory.categoryId);
          this.selectedThesaurusCategory = refreshed || null;
        }
        if (this.activeThesaurusCategory) {
          const refreshedActive = this.filteredCategories.find(c => c.categoryId === this.activeThesaurusCategory.categoryId);
          this.activeThesaurusCategory = refreshedActive || null;
        }

        // If the advanced thesaurus dialog is open, reload the current tree with the new language
        if (this.isThesaurusAdvancedVisible && this.activeThesaurusCategory) {
          this.loadCategoryTree(this.activeThesaurusCategory.categoryId);
        }
      }
    });

    this.fieldsListsService.fieldsLists$.subscribe((fieldsLists) => {
      this.fieldsLists = fieldsLists;
      this.fieldsLists.periods = this.transformToTreeNode(this.fieldsLists.periods);
      this.fieldsLists.findTypes = this.transformToTreeNode(this.fieldsLists.findTypes);
      this.fieldsLists.materials = this.transformToTreeNode(this.fieldsLists.materials);
      
      // Transform and cache thesaurus trees once when data loads
      if (this.fieldsLists.thesaurusAll?.categories?.length) {
        this.initializeThesaurusCategories();
        this.isThesaurusDataLoading = false;
      }
    });
    this.searchFieldsService.searchFields$.subscribe((searchFields) => {
      this.searchFields = searchFields;
      if (searchFields.regions?.length || searchFields.regionIds?.length) {
        this.isRegionVisible = true;
      }
    });
    this.RoutingService.activeTabIndex$.subscribe((tabIndex: number) => {
      this.activeTabIndex = tabIndex;
    });
    this.searchService.isLoadingResults$.subscribe((isLoading: boolean) => {
      this.isLoading = isLoading;
      if (isLoading) {
        this.isCollapsed = true;
      }
    });
    this.searchService.isFirstSearchResReturned$.subscribe((isFirstSearchResReturned: boolean) => {
      this.isCollapsed = isFirstSearchResReturned;
    });
    this.virtualExpeditions = Array.from({ length: 10000 });
    this.searchService.isResultsPopupOpen$.subscribe((isResultsPopupOpen: boolean) => {
      this.handleResultsPopupToggle(isResultsPopupOpen);
    });
  }

  handleResultsPopupToggle(isResultsPopupOpen: boolean) {
    if (!isResultsPopupOpen && this.panelElementRef) {
      const button = this.panelElementRef.nativeElement.querySelector('.p-panel-header .p-panel-toggler');
      if (button) {
        setTimeout(() => {
          button.focus();
        }, 0);
      }
    }
  }

  populateMapControls(): void {
    this.mapControls = [
      { position: 'top-left', type: ControlType.FullScreen },
      { position: 'top-left', type: ControlType.Zoom },
      {
        position: 'top-left',
        type: ControlType.Locate,
        attributes: { scale: 100 },
      },
      {
        position: 'top-left',
        type: ControlType.Search,
        attributes: {
          includeDefaultSourcesDisabled: true
        },
        expand: {
          id: 'search-expand',
          position: 'top-left',
          expandIcon: 'search',
          expandTooltip: `${this.translate.instant('iaa.map.search-gush-parcel')}`,
          mode: 'floating',
        },
      },
     {
			position: 'top-left',
			type: ControlType.LayerList,
			expand: {
				id: 'layer-list-expand',
				position: 'top-left',
				expandIcon: 'layers',
				expandTooltip: `${this.translate.instant('iaa.map.expand-layers')}`,
				mode: 'floating',
			},
		},
      {
        position: 'bottom-right',
        type: ControlType.EditGeometry,
        attributes: {
          defaultGraphicsLayerDisabled: true,
        }
      },
    {
			position: 'top-left',
			type: ControlType.AreaMeasurement2D,
			attributes: {
				unit: 'metric',
				locale: this.currentLanguage
			},
			expand: {
				position: 'top-left',
				expandIcon: 'polygon',
				expandTooltip: `${this.translate.instant('iaa.map.expand-area-measurement')}`,
				mode: 'floating',
			},
		},
    {
			position: 'top-left',
			type: ControlType.DistanceMeasurement2D,
			attributes: {
				unit: 'metric',
				locale: this.currentLanguage
			},
			expand: {
				position: 'top-left',
				expandIcon: 'measure-line',
				expandTooltip: `${this.translate.instant('iaa.map.expand-distance-measurement')}`,
				mode: 'floating',
			},
		},
    ];
  }

  addFreeTextTag() {
    if (this.freeText) {
      this.searchFieldsService.addSearchField(RequestKeys.FREE_TEXT, {
        id: this.freeText,
        label: new MultiLangStrDto(this.freeText, this.freeText),
      });
      this.freeText = '';
    }
    this.isSearchTriggered && (this.isSearchValid = this.validateFields());
  }

  removeFreeTextTag(field: SearchFieldDto) {
    if (field) {
      this.searchFieldsService.removeSearchField(RequestKeys.FREE_TEXT, field);
    }
  }

  removeTag(field: SearchFieldDto, category: keyof SearchFieldsDto) {
    if (field) {
      this.searchFieldsService.removeSearchField(category, field);
    }
  }
  toggleField(requestKey: RequestKeys, element: any) {
    if (!element) return;
    
    // Handle advanced thesaurus differently - use temporary storage
    if (requestKey === RequestKeys.ADVANCED_THESAURUS && this.isThesaurusAdvancedVisible) {
      this.toggleAdvancedThesaurusField(element);
      return;
    }
    
    const mapping = FIELD_MAPPING[requestKey];
    const id = element[mapping.id].toString();
    const label = element[mapping.label];
    if (!this.searchFields[requestKey]?.find((t) => t.id === id)) {
      const searchField: SearchFieldDto = { id, label };
      if (element.wid !== undefined) {
        searchField.wid = element.wid.toString();
      }
      if (element.address !== undefined) {
        searchField.address = element.address;
      }
      this.searchFieldsService.addSearchField(requestKey, searchField);
      this.isSearchTriggered && (this.isSearchValid = this.validateFields());
    }
  }

  toggleAdvancedThesaurusField(element: any) {
    const categoryId = this.selectedThesaurusCategory.categoryId === -1 
      ? element.categoryId 
      : this.selectedThesaurusCategory.categoryId;
    
    if (!categoryId || categoryId === -1) {
      console.error('Cannot add selection: categoryId is missing or invalid', element);
      return;
    }
    
    const mapping = FIELD_MAPPING[RequestKeys.ADVANCED_THESAURUS];
    // Use address as the unique identifier
    const id = element.address || element[mapping.id].toString();
    const label = element[mapping.label];
    
    if (!this.tempAdvancedThesaurusSelections[categoryId]) {
      this.tempAdvancedThesaurusSelections[categoryId] = [];
    }
    
    const existingIndex = this.tempAdvancedThesaurusSelections[categoryId].findIndex((t) => t.id === id);
    
    if (existingIndex === -1) {
      const searchType = this.searchTypePreferences[categoryId]?.[id] || 'branch';
      
      const searchField: SearchFieldDto = { 
        id, 
        label, 
        categoryId,
        searchType
      };
      if (element.wid !== undefined) {
        searchField.wid = element.wid.toString();
      }
      if (element.address !== undefined) {
        searchField.address = element.address;
      }
      if (element.data !== undefined) {
        searchField.mid = element.data;
      }
      this.tempAdvancedThesaurusSelections[categoryId].push(searchField);
    } else {
      this.tempAdvancedThesaurusSelections[categoryId].splice(existingIndex, 1);
      if (this.tempAdvancedThesaurusSelections[categoryId].length === 0) {
        delete this.tempAdvancedThesaurusSelections[categoryId];
      }
    }
    
    // Update cached grouped selections
    this.updateCachedGroupedSelections();
  }


openExpeditionDialog() {
  this.prepareCombinedExpeditionValues();
  this.isExpeditionDialogVisible = true;
}

closeExpeditionDialog() {
  this.isExpeditionDialogVisible = false;
}

prepareCombinedExpeditionValues() {
  const expeditionLicenseIds = new Set<number>();
  this.fieldsLists.expeditions.forEach(expedition => {
    expedition.licenseIds?.forEach(licenseId => expeditionLicenseIds.add(licenseId));
  });
  
  // Filter licenses to only those related to expeditions
  const expeditionLicenses = this.fieldsLists.licenses.filter(license => 
    expeditionLicenseIds.has(license.licenseId)
  );
  
  this.combinedExpeditionValues = [
    ...expeditionLicenses.map(license => ({
      id: `license_${license.licenseId}`,
      name: license.longName,
      type: 'license',
      originalItem: license
    })),
    ...this.fieldsLists.expeditions.map(expedition => ({
      id: `expedition_${expedition.expeditionId}`,
      name: this.currentLanguage === 'he' ? expedition.expeditionName.hebrew : expedition.expeditionName.english,
      type: 'expedition',
      originalItem: expedition
    }))
  ];
}

openExcavationsAndSurveysDialog() {
  this.prepareCombinedExcavationsAndSurveysValues();
  this.isExcavationsAndSurveysDialogVisible = true;
}

prepareCombinedExcavationsAndSurveysValues() {
  const excavationLicenseIds = new Set<number>();
  const surveyLicenseIds = new Set<number>();
  
  this.fieldsLists.excavations.forEach(excavation => {
    excavation.licenseIds?.forEach(licenseId => excavationLicenseIds.add(licenseId));
  });
  
  this.fieldsLists.surveys.forEach(survey => {
    survey.licenseIds?.forEach(licenseId => surveyLicenseIds.add(licenseId));
  });
  
  // Filter licenses to only those related to excavations or surveys
  const allLicenseIds = new Set([...excavationLicenseIds, ...surveyLicenseIds]);
  const relatedLicenses = this.fieldsLists.licenses.filter(license => 
    allLicenseIds.has(license.licenseId)
  );
  
  this.combinedExcavationsAndSurveysValues = [
    ...relatedLicenses.map(license => ({
      id: `license_${license.licenseId}`,
      name: license.longName,
      type: 'license',
      originalItem: license
    })),
    ...this.fieldsLists.excavations.map(excavation => ({
      id: `excavation_${excavation.excavationId}`,
      name: this.currentLanguage === 'he' ? excavation.excavationName.hebrew : excavation.excavationName.english,
      type: 'excavation',
      originalItem: excavation
    })),
    ...this.fieldsLists.surveys.map(survey => ({
      id: `survey_${survey.entitySurveyId}`,
      name: this.currentLanguage === 'he' ? survey.surveyName.hebrew : survey.surveyName.english,
      type: 'survey',
      originalItem: survey
    }))
  ];
}

handleExpeditionToggleTag(item: any) {
  if (!item) return;
  if (item.type === 'license') {
    this.toggleField(RequestKeys.EXPEDITION_LICENSES, item.originalItem);
  } else if (item.type === 'expedition') {
    this.toggleField(RequestKeys.EXPEDITIONS, item.originalItem);
  }
}

handleExcavationAndSurveyToggleTag(item: any) {
  if (!item) return;
  if (item.type === 'license') {
    // Determine if license is for excavation or survey based on license IDs
    const isExcavationLicense = this.fieldsLists.excavations.some(exc => 
      exc.licenseIds?.includes(item.originalItem.licenseId)
    );
    const isSurveyLicense = this.fieldsLists.surveys.some(srv => 
      srv.licenseIds?.includes(item.originalItem.licenseId)
    );
    
    // Add to both if license belongs to both types
    if (isExcavationLicense) {
      this.toggleField(RequestKeys.EXCAVATION_LICENSES, item.originalItem);
    }
    if (isSurveyLicense) {
      this.toggleField(RequestKeys.SURVEY_LICENSES, item.originalItem);
    }
  } else if (item.type === 'excavation') {
    this.toggleField(RequestKeys.EXCAVATIONS, item.originalItem);
  } else if (item.type === 'survey') {
    this.toggleField(RequestKeys.SURVEYS, item.originalItem);
  }
}

  search() { 
    this.isSearchTriggered = true;
    this.isDrawPolygon = false;
    this.addFreeTextTag();
    if (!this.validateFields()) {
      this.isSearchValid = false;
      return;
    }
    this.collapsePanel();
    this.isSearchValid = true;
    this.isSearchTriggered = false;
    // Clear previous search results and filters before new search
    this.searchService.clearSearchResults();
    // Only switch to list if currently on map tab (after clear to avoid timing issues)
    if (this.activeTabIndex === TabId.MAP) {
      this.RoutingService.updateActiveTabIndex(TabId.LIST);
    }
    this.searchService.search().subscribe({
      next: () => {
        this.searchService.setSearchParams();
      },
      error: (e) => {
        if (e.status === 400 && e.error.code === 'TOO_MANY_ROWS') {
          this.searchService.clearSearchResults();
        }
        else {
          this.showError(`Search failed: ${e.message}`);
        }
        this.searchService.setSearchParams();
        console.error(e);
      },
    });
  }

  showSuccess(message: string) {
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: message,
    });
  }

  showInfo(message: string) {
    this.messageService.add({
      severity: 'info',
      summary: 'Info',
      detail: message,
    });
  }

  showWarn(message: string) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Warn',
      detail: message,
    });
  }

  showError(message: string) {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: message,
    });
  }
  cancel() {
    this.searchService.cancel();
  }

  clear() {
    this.searchFieldsService.clearSearchFields();
    this.regions = [];
    this.polygons = [];
    this.isSearchValid = true;
    this.isSearchTriggered = false;
  }

  validateFields() {
    const totalLength = Object.values(RequestKeys).reduce((total, key) => {
      const length = this.searchFields[key]?.length || 0;
      return total + length;
    }, 0);

    return !!totalLength;
  }

  loadExpeditionsLazy(event: any) {
    setTimeout(() => {
      let loadedExpeditions = this.searchFields.expeditions.slice(
        event.first ?? 0,
        (event.first ?? 0) + (event.rows ?? 0)
      );
      // @ts-ignore
      this.virtualExpeditions.splice(event.first ?? 0, event.rows ?? 0, ...loadedExpeditions);
      event.forceUpdate();
    }, 100);
  }

  removeAllRegionsTag(category: keyof SearchFieldsDto) {
    // delete the tag of regions when we want to dleete all polygons on the map
    this.searchFieldsService.removeAllKeySearchFields(category);
    this.onMapRegionsDeleted = true;
    this.regions = [];
    this.polygons = [];
  }
  updateRegionTag() {
    const currentSearchFields = this.searchFields;
    const regionsLength = this.regions.length;
    const searchFieldsRegionsLength = currentSearchFields.regions?.length || 0;

    if (regionsLength === searchFieldsRegionsLength) {
      // Check if any region's wkt has changed
      this.regions.forEach((region, index) => {
        const searchFieldRegion = currentSearchFields.regions[index];
        if (region.wkt !== searchFieldRegion.id) {
          // If wkt has changed, update the search field
          this.searchFieldsService.removeSearchField(
            RequestKeys.REGIONS,
            searchFieldRegion
          );
          this.searchFieldsService.addSearchField(RequestKeys.REGIONS, {
            id: region.wkt,
            label: new MultiLangStrDto(`${index + 1} פוליגונים על המפה`, `${index + 1} Polygons on the map`)
          });
        }
      });
      // Update the polygons we send back to esri
      this.polygons = this.regions;
    }
    else if (regionsLength > searchFieldsRegionsLength) {
      // Add the last region to the search fields
      const lastRegion = this.regions[regionsLength - 1].wkt;
      if (
        !currentSearchFields.regions?.some((region) => region.id === lastRegion)
      ) {
        this.$gaService.event(`new polygon drawn on search map`);

        this.searchFieldsService.addSearchField(RequestKeys.REGIONS, {
          id: lastRegion,
          label: new MultiLangStrDto(regionsLength.toString() + ' פוליגונים על המפה', regionsLength.toString() + ' Polygons on the map')
        });
        this.polygons = this.regions;
      }
    }
    // If there are fewer regions than search fields
    else {
      // Remove regions that are not in this.regions but still in searchFields.regions
      const regionWkts = this.regions.map((region) => region.wkt);
      const regionsToRemove = currentSearchFields.regions?.filter(
        (searchFieldRegion) => !regionWkts.includes(searchFieldRegion.id)
      ) || [];
      
      regionsToRemove.forEach((regionWkt) => {
        this.searchFieldsService.removeSearchField(RequestKeys.REGIONS, {
          id: regionWkt.id,
          label: regionWkt.label,
        });
        if (this.regions.length != 0) {
          this.searchFields.regions[this.searchFields.regions.length - 1].label = new MultiLangStrDto(regionsLength.toString() + ' פוליגונים על המפה', regionsLength.toString() + ' Polygons on the map');
        }
      });
      this.polygons = this.regions;
    }
    // Validate the fields if a search is triggered
    this.isSearchTriggered && (this.isSearchValid = this.validateFields());
  }

  handleSketchShapesChanged(shapes: ShapeItem[]): void {
    
    const newShapes = shapes.map((shape, index) => {
      return {
        wkt: shape.wkt,
        layerName: shape.layerName,
        shapeId: index.toString(),
        shapeData: shape.shapeData || {},
        hidden: shape.hidden,
        styledParams: {
          geometryType: "Polygon",
          fillColor: shape.styledParams.fillColor,
          borderColor: shape.styledParams.borderColor,
          borderWidth: shape.styledParams.borderWidth,
        }
      };
    });

    // Update regions array with new reference to trigger change detection
    this.regions = [...newShapes];
  }

  /**
   * Handle drawing polygons - called when user approves the sketch
   */
  drawPolygons() {
    this.isDrawPolygon = false;
    if (this.regions.length > 0) {
      this.updateRegionTag();
    }
  }

  /**
   * Cancel drawing polygons - called when user cancels the sketch
   */
  cancelDrawingPolygons() {
    this.isDrawPolygon = false;
    this.regions = [];
    this.polygons = [];
    this.searchFields.regions = [];// Clear any existing region search fields
    this.searchFieldsService.removeAllKeySearchFields(RequestKeys.REGIONS);
  }

  /**
   * Handle dialog reopening - restore sketch shapes
   */
  onDrawPolygonDialogOpen(): void {
    setTimeout(() => {
      this.populateMapControls();
    }, 100);
  }

  toggleRegionVisibility() {
    this.isRegionVisible = !this.isRegionVisible;
  }
  toggleHeritageSiteVisibility() {
    this.isHeritageSiteVisible = !this.isHeritageSiteVisible;
  }
  toggleExpeditionVisibility() {
    this.isExpeditionVisible = !this.isExpeditionVisible;
  }
  toggleExcavationsAndSurveysVisibility() {
    this.isExcavationsAndSurveysVisible = !this.isExcavationsAndSurveysVisible;
  }
  toggleDrawPolygonVisibility() {
    this.isDrawPolygon = !this.isDrawPolygon;
  }

  openThesaurusAdvanced() {
    this.tempAdvancedThesaurusSelections = {};
    this.searchTypePreferences = {};
    this.cachedGroupedSelections = [];
    
    this.filteredCategories = this.thesaurusAllCategories.map(cat => ({
      ...cat,
      displayText: this.currentLanguage === 'he' ? cat.categoryName.hebrew : cat.categoryName.english
    }));

    // Always start with "All Categories" on each dialog open
    const allCategoriesOption = this.filteredCategories.find(cat => cat.categoryId === -1);
    this.selectedThesaurusCategory = allCategoriesOption || null;
    this.activeThesaurusCategory = allCategoriesOption || null;
    
    this.isThesaurusAdvancedVisible = true;
    
    // Lazy load on first interaction - defer to next tick
    setTimeout(() => {
      this.advancedThesaurusTree?.clearFilter();
      
      this.initializeThesaurusData();
      
      if (this.activeThesaurusCategory) {
        this.loadCategoryTree(this.activeThesaurusCategory.categoryId);
      }
    }, 0);
  }

  onThesaurusDialogShow() {
    setTimeout(() => {
      const dropdownButton = document.querySelector('.thesaurus-advanced-dialog .p-autocomplete-dropdown');
      if (dropdownButton instanceof HTMLElement) {
        dropdownButton.focus();
      }
    }, 100);
  }

  private initializeThesaurusData() {
    // Always reinitialize from committed search fields
    // Import selections from specific category trees (period, material, findTypes)
    this.importSpecificCategorySelections();
    
    if (this.searchFields[RequestKeys.ADVANCED_THESAURUS]?.length > 0) {
      this.searchFields[RequestKeys.ADVANCED_THESAURUS].forEach(field => {
        if (field.categoryId !== undefined) {
          if (!this.tempAdvancedThesaurusSelections[field.categoryId]) {
            this.tempAdvancedThesaurusSelections[field.categoryId] = [];
          }
          
          const tempField: SearchFieldDto = {
            id: field.id,
            label: field.label,
            categoryId: field.categoryId,
            searchType: field.searchType || 'branch',
            mid: field.mid,
            wid: field.wid,
            address: field.address
          };
          
          this.tempAdvancedThesaurusSelections[field.categoryId].push(tempField);
          
          if (!this.searchTypePreferences[field.categoryId]) {
            this.searchTypePreferences[field.categoryId] = {};
          }
          this.searchTypePreferences[field.categoryId][field.id] = field.searchType || 'branch';
        }
      });
    }
    
    this.updateCachedGroupedSelections();
  }

  private importSpecificCategorySelections() {
    // Mapping of RequestKeys to CategoryIds
    const categoryMapping: { [key: string]: number } = {
      [RequestKeys.PERIOD_MIDS]: 4, // PERIOD
      [RequestKeys.MATERIAL_MIDS]: 9, // MATERIAL
      [RequestKeys.FIND_TYPE_MIDS]: 2 // OBJECT_TYPE
    };

    // Import selections from each specific category
    Object.keys(categoryMapping).forEach((requestKey: string) => {
      const categoryId = categoryMapping[requestKey];
      const selections = this.searchFields[requestKey as keyof SearchFieldsDto];
      
      if (selections && Array.isArray(selections) && selections.length > 0) {
        // Initialize category array if needed
        if (!this.tempAdvancedThesaurusSelections[categoryId]) {
          this.tempAdvancedThesaurusSelections[categoryId] = [];
        }
        
        selections.forEach((field: SearchFieldDto) => {
          // Add to temp selections with branch as default search type
          const tempField: SearchFieldDto = {
            id: field.id,
            label: field.label,
            categoryId: categoryId,
            searchType: 'branch',
            mid: field.mid,
            wid: field.wid,
            address: field.address
          };
          
          // Only add if not already present
          if (!this.tempAdvancedThesaurusSelections[categoryId].find(s => s.id === field.id)) {
            this.tempAdvancedThesaurusSelections[categoryId].push(tempField);
          }
          
          // Store search type preference
          if (!this.searchTypePreferences[categoryId]) {
            this.searchTypePreferences[categoryId] = {};
          }
          this.searchTypePreferences[categoryId][field.id] = 'branch';
        });
      }
    });
    
    // Update cached grouped selections
    this.updateCachedGroupedSelections();
  }

  private initializeThesaurusCategories(): void {
    this.transformedThesaurusTrees = {};
    this.cachedMergedTree = null; // Clear merged tree cache
    this.thesaurusAllCategories = [
      // Add "All Categories" as first option
      {
        categoryId: -1,
        categoryName: { hebrew: 'כל הקטגוריות', english: 'All Categories' },
        tree: null
      },
      ...this.fieldsLists.thesaurusAll.categories.map((cat: any) => {
        const transformedTree = this.transformToTreeNode(cat.tree);
        this.transformedThesaurusTrees[cat.categoryId] = transformedTree;
        return {
          categoryId: cat.categoryId,
          categoryName: cat.categoryName,
          tree: transformedTree
        };
      })
    ];
  }

  private loadCategoryTree(categoryId: number) {
    // Null out the tree so Angular destroys the component (clears PrimeNG internal state).
    this.currentAdvancedThesaurusTree = null;
    this.cdr.detectChanges();

    // Microtask runs sub-frame — imperceptible to user — then recreates with clean state.
    Promise.resolve().then(() => {
      this.ngZone.run(() => {
        let tree: ThesaurusTreeNode | null = null;
        if (categoryId === -1) {
          if (!this.cachedMergedTree) {
            this.cachedMergedTree = this.createMergedCategoriesTree();
          }
          tree = this.cachedMergedTree;
        } else {
          tree = this.transformedThesaurusTrees[categoryId] ?? null;
        }

        if (tree) {
          this.collapseAllNodes(tree, true);
        }
        this.currentAdvancedThesaurusTree = tree;
      });
    });
  }

  private collapseAllNodes(node: ThesaurusTreeNode, isRoot: boolean = false): void {
    node.expanded = isRoot;
    if (node.children) {
      for (const child of node.children) {
        this.collapseAllNodes(child, false);
      }
    }
  }

  private createMergedCategoriesTree(): ThesaurusTreeNode {
    const allCategoriesLabel = this.currentLanguage === 'he' ? 'כל הקטגוריות' : 'All Categories';
    
    const mergedTree: ThesaurusTreeNode = {
      key: 'all-categories-root',
      label: allCategoriesLabel,
      data: 'all-categories-root',
      expanded: true,
      selectable: true,
      styleClass: 'all-categories-root',
      leaf: false,
      parent: undefined,
      multiLangLabel: {
        hebrew: 'כל הקטגוריות',
        english: 'All Categories'
      },
      children: this.thesaurusAllCategories
        .filter(cat => cat.categoryId !== -1) // Exclude "All Categories" itself from the merged tree
        .map(cat => {
        const categoryTree = this.transformedThesaurusTrees[cat.categoryId];
        const hebrewPrefix = 'קטגוריה: ';
        const englishPrefix = 'Category: ';
        const categoryLabel = this.currentLanguage === 'he' ? cat.categoryName.hebrew : cat.categoryName.english;
        
        // Create a category wrapper node and propagate categoryId to all descendants
        const categoryNode: ThesaurusTreeNode = {
          key: `category-${cat.categoryId}`,
          label: (this.currentLanguage === 'he' ? hebrewPrefix : englishPrefix) + categoryLabel,
          data: `category-${cat.categoryId}`,
          categoryId: cat.categoryId,
          expanded: false,
          selectable: true,
          leaf: false,
          styleClass: 'category-header-node',
          children: this.propagateCategoryId(categoryTree?.children || [], cat.categoryId),
          multiLangLabel: {
            hebrew: hebrewPrefix + cat.categoryName.hebrew,
            english: englishPrefix + cat.categoryName.english
          }
        };
        
        return categoryNode;
      })
    };
    
    return mergedTree;
  }

  private propagateCategoryId(nodes: ThesaurusTreeNode[], categoryId: number): ThesaurusTreeNode[] {
    return nodes.map(node => {
      return {
        ...node,
        categoryId: categoryId,
        equalWids: node.equalWids,
        unprefWids: node.unprefWids,
        multiLangLabel: node.multiLangLabel,
        searchableText: node.searchableText,
        data: node.data,
        wid: node.wid,
        address: node.address,
        children: node.children ? this.propagateCategoryId(node.children, categoryId) : undefined
      };
    });
  }

  onCategorySelect(event: any) {
    // Extract the actual category value from the event
    const category = event.value || event;
    this.selectedThesaurusCategory = category;
    this.activeThesaurusCategory = category;
    this.loadCategoryTree(category.categoryId);
    setTimeout(() => {
      this.advancedThesaurusTree?.clearFilter();
    }, 0);
  }

  filterCategories(event: any) {
    const query = event.query.toLowerCase();
    this.filteredCategories = this.thesaurusAllCategories
      .filter(category => {
        if (!query) return true; // Show all when no query
        const hebrewName = category.categoryName?.hebrew?.toLowerCase() || '';
        const englishName = category.categoryName?.english?.toLowerCase() || '';
        return hebrewName.includes(query) || englishName.includes(query);
      })
      .map(cat => ({
        ...cat,
        displayText: this.currentLanguage === 'he' ? cat.categoryName.hebrew : cat.categoryName.english
      }));
  }

  closeThesaurusAdvanced() {
    // Remove values from specific category sections that are now in temp selections
    this.removeSpecificCategoryDuplicates();
    
    // Remove items from searchFields that are not in tempAdvancedThesaurusSelections
    const allTempSelectionIds = new Set<string>();
    Object.keys(this.tempAdvancedThesaurusSelections).forEach(categoryId => {
      this.tempAdvancedThesaurusSelections[+categoryId].forEach(selection => {
        allTempSelectionIds.add(selection.id);
      });
    });
    
    // Remove items that are no longer selected
    if (this.searchFields[RequestKeys.ADVANCED_THESAURUS]) {
      const itemsToRemove = this.searchFields[RequestKeys.ADVANCED_THESAURUS].filter(
        field => !allTempSelectionIds.has(field.id)
      );
      itemsToRemove.forEach(field => {
        this.searchFieldsService.removeSearchField(RequestKeys.ADVANCED_THESAURUS, field);
      });
    }
    
    // Commit temporary selections to actual search fields
    Object.keys(this.tempAdvancedThesaurusSelections).forEach(categoryId => {
      const category = this.thesaurusAllCategories.find(cat => cat.categoryId.toString() === categoryId);
      const categoryName = category?.categoryName || { hebrew: 'Category', english: 'Category' };
      
      this.tempAdvancedThesaurusSelections[+categoryId].forEach(selection => {
        // Store labels without prefix in label, but include prefix for display
        const searchField: SearchFieldDto = {
          id: selection.id,
          label: selection.label,
          mid: selection.mid,
          wid: selection.wid,
          address: selection.address,
          categoryId: +categoryId,
          searchType: selection.searchType || 'branch', // Preserve search type
          prefix: categoryName // Store category name for display
        };
        
        const existingSelection = this.searchFields[RequestKeys.ADVANCED_THESAURUS]?.find((t) => t.id === selection.id);
        
        if (existingSelection) {
          existingSelection.searchType = selection.searchType || 'branch';
        } else {
          this.searchFieldsService.addSearchField(RequestKeys.ADVANCED_THESAURUS, searchField);
        }
      });
    });
    
    this.tempAdvancedThesaurusSelections = {};
    this.searchTypePreferences = {};
    this.cachedGroupedSelections = [];
    this.currentAdvancedThesaurusTree = null as any;
    this.isThesaurusAdvancedVisible = false;
    this.isSearchTriggered && (this.isSearchValid = this.validateFields());
  }

  private removeSpecificCategoryDuplicates() {
    const categoryToRequestKeyMapping: { [key: number]: keyof SearchFieldsDto } = {
      4: RequestKeys.PERIOD_MIDS,
      9: RequestKeys.MATERIAL_MIDS,
      2: RequestKeys.FIND_TYPE_MIDS
    };

    // Check each category in temp selections
    Object.keys(this.tempAdvancedThesaurusSelections).forEach(categoryId => {
      const categoryIdNum = parseInt(categoryId);
      const requestKey = categoryToRequestKeyMapping[categoryIdNum];
      
      if (requestKey) {
        // Get all IDs from temp selections for this category
        const tempSelectionIds = this.tempAdvancedThesaurusSelections[categoryIdNum].map(s => s.id);
        
        // Remove matching items from specific category section
        if (this.searchFields[requestKey]) {
          tempSelectionIds.forEach(id => {
            const field = this.searchFields[requestKey]?.find((f: SearchFieldDto) => f.id === id);
            if (field) {
              this.searchFieldsService.removeSearchField(requestKey, field);
            }
          });
        }
      }
    });
  }

  cancelThesaurusAdvanced() {
    // Discard temporary selections, preferences and close dialog
    this.tempAdvancedThesaurusSelections = {};
    this.searchTypePreferences = {};
    this.cachedGroupedSelections = [];
    this.currentAdvancedThesaurusTree = null as any;
    this.isThesaurusAdvancedVisible = false;
  }

  onSearchTypeChange(event: {tag: SearchFieldDto, searchType: ThesaurusSearchType}) {
    // Update the search type for the field in searchFields
    const field = this.searchFields[RequestKeys.ADVANCED_THESAURUS]?.find(f => f.id === event.tag.id && f.categoryId === event.tag.categoryId);
    if (field) {
      field.searchType = event.searchType;
      this.isSearchTriggered && (this.isSearchValid = this.validateFields());
    }
  }
  getCurrentCategoryTempSelections(): SearchFieldDto[] {
    if (!this.selectedThesaurusCategory) {
      return [];
    }
    const categoryId = this.selectedThesaurusCategory.categoryId;
    
    // If "All Categories" is selected, return all selections from all categories
    if (categoryId === -1) {
      return Object.values(this.tempAdvancedThesaurusSelections).flat();
    }
    
    return this.tempAdvancedThesaurusSelections[categoryId] || [];
  }

  getCurrentCategorySearchTypePreferences(): { [nodeId: string]: ThesaurusSearchType } {
    if (!this.selectedThesaurusCategory) {
      return {};
    }
    const categoryId = this.selectedThesaurusCategory.categoryId;
    
    // If "All Categories" is selected, merge all preferences
    if (categoryId === -1) {
      const mergedPreferences: { [nodeId: string]: ThesaurusSearchType } = {};
      Object.values(this.searchTypePreferences).forEach(prefs => {
        Object.assign(mergedPreferences, prefs);
      });
      return mergedPreferences;
    }
    
    return this.searchTypePreferences[categoryId] || {};
  }

  onTreeNodeSearchTypeChange(event: {node: ThesaurusTreeNode, searchType: ThesaurusSearchType}) {
    if (!this.selectedThesaurusCategory) {
      return;
    }
    
    // When "All Categories" is selected, use the node's categoryId
    // Otherwise use the selected category's categoryId
    const categoryId = this.selectedThesaurusCategory.categoryId === -1
      ? event.node.categoryId
      : this.selectedThesaurusCategory.categoryId;
    
    const nodeId = event.node.data?.toString();
    
    // Store the preference for this node (whether or not it's selected)
    if (!this.searchTypePreferences[categoryId]) {
      this.searchTypePreferences[categoryId] = {};
    }
    this.searchTypePreferences[categoryId][nodeId] = event.searchType;
    
    // Also update the selection if it exists
    const selection = this.tempAdvancedThesaurusSelections[categoryId]?.find(s => s.id === nodeId);
    if (selection) {
      selection.searchType = event.searchType;
    }
  }

  getTempSelectionsGroupedByCategory(): Array<{categoryId: number, categoryName: string, selections: SearchFieldDto[]}> {
    return this.cachedGroupedSelections;
  }

  updateCachedGroupedSelections(): void {
    const groups: Array<{categoryId: number, categoryName: string, selections: SearchFieldDto[]}> = [];
    
    // Get all category IDs that have selections
    const categoryIds = Object.keys(this.tempAdvancedThesaurusSelections)
      .map(id => parseInt(id))
      .filter(id => this.tempAdvancedThesaurusSelections[id]?.length > 0)
      .sort((a, b) => a - b); // Sort by category ID
    
    // Build groups with category names
    categoryIds.forEach(categoryId => {
      const categoryName = this.getCategoryName(categoryId);
      const selections = this.tempAdvancedThesaurusSelections[categoryId] || [];
      groups.push({ categoryId, categoryName, selections });
    });
    
    this.cachedGroupedSelections = groups;
  }

  getCategoryName(categoryId: number): string {
    const category = this.thesaurusAllCategories.find(c => c.categoryId === categoryId);
    if (category) {
      return this.currentLanguage === 'he' ? category.categoryName.hebrew : category.categoryName.english;
    }
    return '';
  }

  removeTagFromTempSelections(tag: SearchFieldDto) {
    if (!tag.categoryId) {
      return;
    }
    
    const categoryId = tag.categoryId;
    if (this.tempAdvancedThesaurusSelections[categoryId]) {
      const index = this.tempAdvancedThesaurusSelections[categoryId].findIndex(t => t.id === tag.id);
      if (index !== -1) {
        this.tempAdvancedThesaurusSelections[categoryId].splice(index, 1);
        this.updateCachedGroupedSelections();
      }
    }
  }

  onPreviewPanelSearchTypeChange(event: {tag: SearchFieldDto, searchType: ThesaurusSearchType}) {
    if (!event.tag.categoryId) {
      return;
    }
    
    const categoryId = event.tag.categoryId;
    const nodeId = event.tag.id;
    
    if (!this.searchTypePreferences[categoryId]) {
      this.searchTypePreferences[categoryId] = {};
    }
    this.searchTypePreferences[categoryId][nodeId] = event.searchType;
    
    const selection = this.tempAdvancedThesaurusSelections[categoryId]?.find(s => s.id === nodeId);
    if (selection) {
      selection.searchType = event.searchType;
    }
    
    this.updateCachedGroupedSelections();
  }



  openSearchSettings() {
    this.tempWithThesaurusAncestors = this.withThesaurusAncestors;
    this.tempWithEntityAncestors = this.withEntityAncestors;
    this.isSearchSettingsVisible = true;
  }

  onSearchSettingsDialogShow() {
    setTimeout(() => {
      const closeButton = document.querySelector('.search-settings-dialog .p-dialog-header-close') as HTMLElement;
      if (closeButton) {
        closeButton.focus();
      }
    }, 100);
  }

  applySearchSettings() {
    const hasChanges = 
      this.tempWithThesaurusAncestors !== this.initialWithThesaurusAncestors ||
      this.tempWithEntityAncestors !== this.initialWithEntityAncestors;

    if (hasChanges) {
      this.withThesaurusAncestors = this.tempWithThesaurusAncestors;
      this.withEntityAncestors = this.tempWithEntityAncestors;
      
      this.searchService.toggleWithThesaurusAncestors(this.withThesaurusAncestors);
      this.searchService.toggleWithEntityAncestors(this.withEntityAncestors);
      this.initialWithThesaurusAncestors = this.withThesaurusAncestors;
      this.initialWithEntityAncestors = this.withEntityAncestors;
      
      const shouldTriggerSearch = this.isLoading || (this.searchService.searchResults$ && (() => {
        let hasResults = false;
        const subscription = this.searchService.searchResults$.subscribe(results => {
          hasResults = results && results.length > 0;
        });
        subscription.unsubscribe();
        return hasResults;
      })());
      
      if (this.isLoading) {
        this.searchService.cancel();
      }
      
      if (shouldTriggerSearch) {
        this.search();
      }
    }
    
    this.isSearchSettingsVisible = false;
  }

  closeSearchSettings() {
    this.tempWithThesaurusAncestors = this.withThesaurusAncestors;
    this.tempWithEntityAncestors = this.withEntityAncestors;
    this.isSearchSettingsVisible = false;
  }

  onSearchSettingsDialogHide() {
    this.tempWithThesaurusAncestors = this.withThesaurusAncestors;
    this.tempWithEntityAncestors = this.withEntityAncestors;
    
    const settingsIcon = document.querySelector('.search-settings-icon') as HTMLElement;
    if (settingsIcon) {
      settingsIcon.focus();
    }
  }

  collapsePanel(): void {
    if (!this.panelRef.collapsed) {
      const syntheticEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });
      this.panelRef.toggle(syntheticEvent);
      this.isCollapsed = true;
    }
  }


  transformToTreeNode(node: ThesaurusTreeNode): ThesaurusTreeNode {
    if (node?.multiLangLabel) {
      node.label = this.currentLanguage === 'he' ? node?.multiLangLabel.hebrew : node?.multiLangLabel.english;
      
      const searchableTexts: string[] = [
        this.currentLanguage === 'he' ? node.multiLangLabel.hebrew : node.multiLangLabel.english
      ];
      
      // Add equal words
      if (node.equalWids && node.equalWids.length > 0) {
        node.equalWids.forEach(equalWord => {
          searchableTexts.push(
            this.currentLanguage === 'he' ? equalWord.name.hebrew : equalWord.name.english
          );
        });
      }
      
      // Add unpref words
      if (node.unprefWids && node.unprefWids.length > 0) {
        node.unprefWids.forEach(unprefWord => {
          searchableTexts.push(
            this.currentLanguage === 'he' ? unprefWord.name.hebrew : unprefWord.name.english
          );
        });
      }
      
      // Join all searchable text with spaces for filtering
      node.searchableText = searchableTexts.filter(text => text).join(' ');
    }
    if (node.children) {
      node.children = node?.children.map((child) =>
        this.transformToTreeNode(child)
      );
    }
    return node;
  }

  ngOnDestroy(): void {
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }

}
